<template>
  <div class="container users">
    <div v-if="isFetchingScopedUsers">
      <v-skeleton-loader type="list-item" v-for="i in 5" :key="i" />
    </div>
    <div v-else>
      <ScopedUserItem v-for="user in scopedUsers" :user="user" :key="user.id" />
    </div>
  </div>
</template>

<script>
import { ORGANISATION_UNITS_NAMESPACE } from "@/store/modules/organisations/organisation-units";
import { copyState } from "@/utils/helpers";
import { createNamespacedHelpers } from "vuex";
import ScopedUserItem from "@/views/settings/Organisation/Units/details/ScopedUserItem";
import { FETCH_SCOPED_USERS } from "@/store/modules/organisations/organisation-units/actions";

const { mapState, mapActions } = createNamespacedHelpers(
  ORGANISATION_UNITS_NAMESPACE
);

export default {
  components: {
    ScopedUserItem
  },
  props: {
    searchText: String,
    unit: Object
  },
  created() {
    this.fetchScopedUsers(this.unit.id);
  },
  computed: {
    ...mapState(copyState(["scopedUsers", "isFetchingScopedUsers"]))
  },
  methods: {
    ...mapActions({
      fetchScopedUsers: FETCH_SCOPED_USERS
    })
  }
};
</script>

<style scoped></style>
